import { useTranslation } from "react-i18next";
import { useAppSelector } from "../app/hooks";
import LeftMenu from "../components/LeftMenu";
import Breadcrumbs from "../components/Breadcrumbs";
import { ImportSourceForm } from "../features/assistant-import/components/ImportSourceForm";
import { ProposalReview } from "../features/assistant-import/components/ProposalReview";
import { ImportResultSummary } from "../features/assistant-import/components/ImportResultSummary";
import {
  selectImportProposal,
  selectImportResult,
} from "../features/assistant-import/assistant-import-slice";

export default function AssistantImportPage() {
  const { t } = useTranslation();
  const proposal = useAppSelector(selectImportProposal);
  const result = useAppSelector(selectImportResult);

  return (
    <section>
      <div className="flex h-full gap-4">
        <LeftMenu />
        <div className="w-full p-4 pb-[120px] lg:px-10 lg:pb-10">
          <div className="lg:max-w-[1280px]">
            <Breadcrumbs />
            <div className="space-y-4 py-6 lg:space-y-6">
              <div>
                <h1>{t("assistantImport.title")}</h1>
                <p className="mt-1 text-grey-50 dark:text-grey-70">
                  {result
                    ? t("assistantImport.subtitleResult")
                    : proposal
                      ? t("assistantImport.subtitleReview")
                      : t("assistantImport.subtitleSource")}
                </p>
              </div>
              {result ? (
                <ImportResultSummary result={result} />
              ) : proposal ? (
                <ProposalReview proposal={proposal} />
              ) : (
                <ImportSourceForm />
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
